import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "batchmenu",
  "use": "batchmenu-usage",
  "viewBox": "0 0 203.1 162.47",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 203.1 162.47\" id=\"batchmenu\"><title>资源 90</title><g id=\"batchmenu_图层_2\" data-name=\"图层 2\"><g id=\"batchmenu_图层_1-2\" data-name=\"图层 1\"><path d=\"M21.76,43.5H181.34a21.75,21.75,0,1,0,0-43.5H21.76a21.75,21.75,0,1,0,0,43.5Zm107.6-29h52a7.25,7.25,0,0,1,0,14.5h-52V14.48Zm52,45.12H21.76a21.75,21.75,0,1,0,0,43.5H181.34a21.75,21.75,0,0,0,0-43.5Zm0,29h-81V74.1h81a7.25,7.25,0,0,1,0,14.5Zm0,30.37H21.76a21.75,21.75,0,1,0,0,43.5H181.34a21.75,21.75,0,0,0,0-43.5Zm0,29h-37.5v-14.5h37.47a7.25,7.25,0,0,1,0,14.5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/batchmenu.svg
// module id = WqPv
// module chunks = 268